<template>
  <a-layout id="components-layout-demo-custom-trigger" class="layout-dashboard" >
    <a-layout-sider :style="{background: '#475564'}" v-model="collapsed" :trigger="null" collapsible>
      <!-- <div class="logo" /> -->
      
      <a-menu theme="dark" mode="inline" :default-selected-keys="['1']">
        <a-menu-item key="0">
          <a-icon            
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="() => (collapsed = !collapsed)"
          />
          <span>Menu</span>
        </a-menu-item>
        <a-menu-item key="1" v-if="$store.state.user.role_id === 1 || $store.state.user.role_id === 2">
          <router-link to="/inicio">
            <a-icon type="home" />
						<span class="label">Inicio</span>
					</router-link>
        </a-menu-item>
        <a-menu-item key="4" v-if="$store.state.user.role_id === 1">
          <router-link to="/gestion-cbi">
            <a-icon type="database" />
						<span class="label">Gestión de CBI</span>
					</router-link>
        </a-menu-item>
        
        <a-menu-item key="3" v-if="$store.state.user.role_id === 1">
          <router-link to="/gestion-wifi">
            <a-icon type="wifi" />
						<span class="label">Gestión Wi-fi</span>
					</router-link>
        </a-menu-item>
        <a-menu-item key="2" v-if="$store.state.user.role_id === 1">
          <router-link to="/users">
            <a-icon type="user" />
						<span class="label">Gestión de Usuarios</span>
					</router-link>
        </a-menu-item>
        <a-menu-item class="logout">          
           <router-link to="/">
            <a-icon type="logout" />
						<span class="label">Cerrar sesion</span>
					</router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>      
      <a-layout-content
        :style="{ background: '#fff'}"
      >
        <router-view />        
      </a-layout-content>      
    </a-layout>
  </a-layout>
</template>
<script>
  
  export default {
    data() {
      return {
        collapsed: true,
      };
    },
    methods: {
    },
  };
</script>
<style>
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  #components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
  }

  #components-layout-demo-custom-trigger .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    margin: 16px;
  }
  .logout{
    /* text-align: center; */
    border-top: 2px solid #ffffff;
    bottom: 0;
    margin: auto;
    position: fixed !important;
    /* width: 100%;  */
  }
  .anticon-logout{
    font-size: 20pt !important;
  }

  
</style>